export { JargonFeature } from './lib/jargon'
export { jargonStaticPaths } from './lib/data/jargon-feature-data'
export { RelatedJargon } from './lib/components/related-jargon/related-jargon'
export type {
  JargonHubPreviewProps,
  JargonPageStoryContent,
  JargonPreviewStory as JargonHubPreviewStory,
} from './lib/types'

export { getStaticPropsGenerator } from './lib/get-static-props'
export type { JargonFeatureProps } from './lib/get-static-props'
export { getStaticPathsGenerator } from './lib/get-static-paths'
